import { styled } from '@nykaa/ui-components';
import React, { useEffect } from 'react';
import Button from '@nykaa/ui-components/Button';
import { pushData, pushEvent } from '@nykaa/data-layer/utils';
import { useTheme } from 'emotion-theming';
import Cross from 'components/Icons/Cross';
import { defaultPinkBoxData } from '../Notification';
import { TOP_INAPP_CLICKED } from 'constants/kebabMenu';

interface PinkBoxProps {
  onCrossClick: () => void;
  config: {
    title: string;
    params: {
      [keys: string]: string | number;
    };
  };
}

const Wrapper = styled.div`
  width: 260px;
  padding: ${({ theme }) => theme.spacing.spacing80};
  text-align: left;
  position: relative;
`;

const Title = styled.p`
  ${({ theme }) => theme.typography.subTitleLarge};
  color: #000f1deb;
`;

const Description = styled.p`
  ${({ theme }) => theme.typography.bodySmall};
  margin: ${({ theme: { spacing } }) =>
    `${spacing.spacing20} ${spacing.spacing0} ${spacing.spacing60} ${spacing.spacing0}`};
  color: #000f1deb;
`;

const CrossIcon = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing.spacing80};
  right: ${({ theme }) => theme.spacing.spacing80};
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #adadad;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  svg {
    width: 12px;
    height: 12px;
  }
`;

function PinkBox(props: PinkBoxProps) {
  const theme: Theme = useTheme();
  const { config = defaultPinkBoxData, onCrossClick = () => {} } = props;
  const { title, params = {} } = config;
  const {
    description = '',
    button_text: buttonText = '',
    redirect_url: redirectURL = '',
    font_size: fontSize = 12,
    button_font_size: buttonFontSize,
  } = params;

  const isValidButton = typeof buttonText === 'string';
  const customButtonStyle = {
    ...(buttonFontSize && { fontSize: buttonFontSize }),
    padding: `${theme.spacing.spacing20} ${theme.spacing.spacing80}`,
    borderRadius: theme.borders.radius20,
  };

  const handleOnClick = () => {
    if (typeof redirectURL === 'string') {
      window.location.href = redirectURL;
    }
  };

  useEffect(() => {
    const GAMOOGA_PINKBOX_NOTIFICATION = 'gamoogaPinkBoxNotification';
    const {
      GAMOOGA_NOTIFICATION_UTM_SOURCE,
      GAMOOGA_NOTIFICATION_UTM_MEDIUM,
      GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
      cp_id,
    } = params || {};
    pushData({
      event: GAMOOGA_PINKBOX_NOTIFICATION,
      gamoogaPinkBoxNotification: {
        utmSource: GAMOOGA_NOTIFICATION_UTM_SOURCE,
        utmMedium: GAMOOGA_NOTIFICATION_UTM_MEDIUM,
        utmCampaign: GAMOOGA_NOTIFICATION_UTM_CAMPAIGN,
        cpid: cp_id,
      },
    });
    const inappEventData = `${GAMOOGA_NOTIFICATION_UTM_SOURCE}:${GAMOOGA_NOTIFICATION_UTM_MEDIUM}:${GAMOOGA_NOTIFICATION_UTM_CAMPAIGN}`;
    pushEvent(TOP_INAPP_CLICKED, {
      top_inapp_clicked_value_hit: inappEventData,
    });
  }, [params]);

  return (
    <Wrapper>
      <CrossIcon onClick={onCrossClick}>
        <Cross fill="white" />
      </CrossIcon>
      <Title>{title}</Title>
      <Description style={{ fontSize }}>{description}</Description>
      {isValidButton && (
        <Button
          kind="secondary"
          size="medium"
          shape="pill"
          onClick={handleOnClick}
          style={customButtonStyle}
        >
          {buttonText}
        </Button>
      )}
    </Wrapper>
  );
}

export default PinkBox;
